<template>
  <div>
    <div class='top'>选择人员</div>
    <div class="loading" v-if="showLoading">
      <van-loading type="spinner" />数据加载中...
    </div>
    <div class='record'>
      <div v-for='(item, index) in recordList' :key='index' class='record-list-item'>
        <div @click="goQuery(item)">{{ item.name }}</div>
      </div>
	  <div v-for='(item, index) in listName' :key='index' class='record-list-item'>
	    <div @click="goQueryBindOpenId(item)">{{ item.name }}</div>
	  </div>
    </div>
    <div class='r-query' @click='goQueryUser'>
      <button class="btn">通过 姓名+身份证/电话/学号 查询</button>
    </div>
  </div>
</template>
<script>
export default {
  name: 'list',
  data() {
    return {
      showLoading: 1,
      recordList: [],
	  listName: [],
      page: 1,
      isLoad: false,
      openId: '',
    };
  },
  mounted() {
    this.openId = this.$route.query.openId;
    document.title = '问卷填写';
    this.getData(this.openId);
  },
  methods: {
    /**
     * 获取数据
    */
    async getData(openId){
      let auth =this.$createAuth(this.$md5);
      let _this = this;
      if(!this.isLoad){
        this.isLoad = true;
        let result = await this.$http.get(this.$url.getTopicStudentList,{
          openId: openId,
          auth: auth.code,
          time: auth.time
        });
		
        if (result.message==='Error: Miss auth parameter.'){
          setTimeout(function(){
            _this.showLoading = 0;
            _this.isLoad = false;
            _this.getData(openId);
          },500);
        } else {
          this.showLoading = 0;
		  
          if (result && result.data) {
            this.recordList = result.data.result;
			await this.getListByOpenId();
            if (this.$route.query.studentId && !this.$route.query.fromDetail) {
              let temp = this.recordList.filter(item => item.student_id == this.$route.query.studentId );
              if (temp && temp.length > 0) {
                this.goQuery(temp[0])
              }
            }
          }
          this.isLoad = false;
        }
      }
    },

    goQueryUser() {
      this.$router.push(`/query?openId=${this.$route.query.openId}&fromPage=1`);
    },
    goQuery(item) {
      this.$router.push(`/questionnaireDetail?openId=${this.$route.query.openId}&studentId=${this.$route.query.studentId}&queryId=${item.uid}&queryName=${item.name}`);
    },
	goQueryBindOpenId(item) {
		this.$router.push(`/questionnaireDetail?openId=${this.$route.query.openId}&studentId=${this.$route.query.studentId}&queryId=${item.uid}&queryName=${item.name}`);
	},
	async getListByOpenId() {
	  let auth = this.$createAuth(this.$md5);
	  let result = await this.$http.get(this.$url.getStudentsByOpenId, {
	    openId: this.$route.query.openId,
	    accountId: this.$route.query.accountId,
	    auth: auth.code,
	    time: auth.time
	  });
	  if (result.message === 'Error: Miss auth parameter.') {
	    this.getListByOpenId();
	  } else {
		  console.log("==========")
	    this.listName = result.data.data.filter(item => 
		  !this.recordList.some(record => record.student_id == item.studentId || record.uid == item.uid)
		);
	  }
	},
  }
};
</script>
<style scope lang="less">
.top {
  padding: 0.3rem;
  font-size: 0.32rem;
  font-weight: bold;
  border-bottom: 1px solid #dddddd;
}
.record {
  width: 100%;
  padding-bottom: 4rem;
  .record-list-item {
    div {
      height: 1rem;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      text-align: center;
      line-height: 1rem;
      border-bottom: 1px solid #dddddd;
    }
    &:nth-child(odd) {
      background: #eeeeee;
    }
  }
}

.r-query {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 2rem;
  line-height: 1rem;
  background: #fff;
  text-align: center;
}

.r-query .btn {
  width: 5.5rem;
  height: 1rem;
  margin: 0.4rem auto;
  color: #fff;
  border-radius: 5px;
  background: #5CC4AB;
}
</style>
